(() => {
  const root = document.getElementById('tgw-country-guard');
  if (!root || root.dataset.enabled !== 'true' || root.dataset.designMode === 'true') return;

  const crawlerTokens = [
    'Googlebot', 'Googlebot-Image', 'Googlebot-Video', 'GoogleOther', 'GoogleOther-Image',
    'GoogleOther-Video', 'Google-InspectionTool', 'Storebot-Google', 'AdsBot-Google', 'AdsBot-Google-Mobile',
    'APIs-Google', 'Mediapartners-Google', 'Google-Safety', 'Google-CloudVertexBot', 'Google-Agent',
    'FeedFetcher-Google', 'Google-Read-Aloud', 'bingbot', 'msnbot', 'msnbot-media',
    'adidxbot', 'MicrosoftPreview', 'BingVideoPreview', 'Slurp', 'DuckDuckBot',
    'DuckAssistBot', 'Applebot', 'Qwantbot', 'Qwantbot-news', 'YandexBot',
    'YandexAccessibilityBot', 'YandexAdNet', 'YandexBlogs', 'YandexCalendar', 'YandexCheckBot',
    'YandexDirect', 'YandexDirectDyn', 'YandexFavicons', 'YandexImages', 'YandexImageResizer',
    'YandexMarket', 'YandexMedia', 'YandexMetrika', 'YandexMobileBot', 'YandexNews',
    'YandexPagechecker', 'YandexPartner', 'YandexRCA', 'YandexRenderResourcesBot', 'YandexScreenshotBot',
    'YandexSearchShop', 'YandexSitelinks', 'YandexTracker', 'YandexTurbo', 'YandexVerticals',
    'YandexVideo', 'Baiduspider', 'Baiduspider-render', 'Baiduspider-image', 'PetalBot',
    'Bytespider', 'Yeti', '360Spider', 'Sogou web spider', 'Sogou News Spider',
    'Sogou Pic Spider', 'Sogou inst spider', 'SeznamBot', 'SeznamScreenshotGenerator', 'MojeekBot',
    'Bravebot', 'Barkrowler', 'BLEXBot', 'GPTBot', 'OAI-SearchBot',
    'OAI-AdsBot', 'ChatGPT-User', 'ClaudeBot', 'Claude-SearchBot', 'Claude-User',
    'PerplexityBot', 'Perplexity-User', 'Meta-ExternalAgent', 'Meta-ExternalFetcher', 'Meta-WebIndexer',
    'FacebookBot', 'Amazonbot', 'Amzn-SearchBot', 'Amzn-User', 'MistralAI-User',
    'cohere-ai', 'CCBot', 'Diffbot', 'YouBot', 'Timpibot',
    'AI2Bot', 'AI2Bot-Dolma', 'LinerBot', 'Omgilibot', 'Omgili',
    'AhrefsBot', 'AhrefsSiteAudit', 'SemrushBot', 'SemrushBot-BA', 'SiteAuditBot',
    'MJ12bot', 'DotBot', 'rogerbot', 'SeobilityBot', 'SEOkicks',
    'SEOkicks-Robot', 'DataForSeoBot', 'Screaming Frog SEO Spider', 'Sitebulb', 'Oncrawl',
    'CensysInspect', 'InternetArchiveBot', 'archive.org_bot', 'ia_archiver', 'facebookexternalhit',
    'Facebot', 'Twitterbot', 'LinkedInBot', 'Slackbot', 'Slackbot-LinkExpanding',
    'Slack-ImgProxy', 'Discordbot', 'TelegramBot', 'Pinterestbot', 'Chrome-Lighthouse',
    'Lighthouse', 'HeadlessChrome', 'GTmetrix', 'WebPageTest', 'PingdomBot',
    'Google-CWS', 'Google-GeminiNotebook', 'GoogleMessages', 'Google-Pinpoint', 'GoogleProducer',
    'Google-Site-Verification', 'Google-NotebookLM', 'YandexFeed', 'YaDirectFetcher', 'YandexOntoDB',
    'YandexOntoDBAPI', 'YandexUserproxy', 'YandexVertis', 'YandexVideoParser', 'YandexWebmaster',
    'YandexAdditional', 'YandexAdditionalBot', 'MistralAI-Index', 'MistralAI-Training', 'bedrockbot',
    'amazon-bedrock-knowledgebase-on-behalf-of', 'amazon-Quick-on-behalf-of', 'RSiteAuditor', 'search.marginalia.nu', 'SiteCheckerBotCrawler',
    'SISTRIX Crawler', 'Algolia Crawler', 'Pingdom.com_bot', 'amazon-kendra', 'DatadogSynthetics',
    'Datadog/Synthetics', 'DynatraceSynthetic', 'RuxitSynthetic', 'bigsur.ai', 'GemmetricBot',
    'GemmetricPublicScanner', 'Anomura', 'CloudflareBrowserRenderingCrawler', 'Cloudflare-AI-Search', 'CloudFlare-AlwaysOnline',
    'Cloudflare-Healthchecks', 'Cloudflare-Traffic-Manager', 'CloudFlare-Prefetch', 'Cloudflare-SSLDetector', 'Cloudflare-diagnostics',
    'Cloudflare Custom Hostname Verification', 'PTST', 'Novellum', 'Kimi-User', 'Mozilla-Tabstack',
    'KlaviyoAIBot', 'Agent/AmazonBuyForMe', 'Qwantify', 'StractBot', 'Elastic-Crawler',
    'Elastic Crawler', 'PingdomPageSpeed', 'pingbot', 'StatusCake_Pagespeed_Indev', 'Cloudflare-AutoRAG'
  ];
  const crawlerNames = crawlerTokens.map(token => token.replaceAll('.', '\\.')).join('|');
  const crawlerPattern = new RegExp(`(?:^|[\\s;(])(?:${crawlerNames})(?:[-_][a-z0-9]+)*(?=$|[\\s;/)])`, 'i');
  const crawlerUrlPattern = /(?:^|[\s;(])\+https?:\/\/(?:(?:www\.)?(?:sitebulb\.com|gtmetrix\.com|webpagetest\.org)(?=\/|[\s;)]|$)|developers\.cloudflare\.com\/security-center\/?(?=[\s;)]|$))/i;
  const scopedCrawlerPattern = /(?:^|[\s;(])compatible;\s*Optimizer(?=\/|[\s;)])[^)]*https?:\/\/crawler\.sistrix\.net(?=\/|[\s;)]|$)/i;
  const declaredCrawlerPattern = /(?:^|[\s;(])compatible;\s*[a-z0-9._-]{0,80}(?:bot|spider|crawler)(?=\/|[\s;)]|$)/i;
  let crawler = false;
  try {
    const userAgent = navigator.userAgent;
    crawler = typeof userAgent === 'string' && (crawlerPattern.test(userAgent) || declaredCrawlerPattern.test(userAgent) || crawlerUrlPattern.test(userAgent) || scopedCrawlerPattern.test(userAgent));
  } catch {}
  if (crawler) {
    root.dataset.status = 'crawler_skipped';
    return;
  }

  const countries = new Set((root.dataset.countries || '').split(','));
  const currentCountry = root.dataset.country;
  const key = `tgw-country-guard:v1:${root.dataset.themeId}`;
  const preferenceKey = `${key}:manual`;
  const visitDuration = 30 * 60 * 1000;
  const preferenceDuration = 30 * 24 * 60 * 60 * 1000;
  const autoForm = document.getElementById('TgwCountryGuardForm');
  const notice = document.getElementById('tgw-country-notice');
  const startTime = performance.now();
  let visit;
  let pageActive = true;
  let manualCountry = '';
  let controller;

  const validCountry = value => typeof value === 'string' && countries.has(value.toUpperCase());
  const countryCode = value => validCountry(value) ? value.toUpperCase() : '';
  const read = (storage, storageKey) => {
    try { return JSON.parse(storage.getItem(storageKey) || 'null'); } catch { return null; }
  };
  const write = (storage, storageKey, value) => {
    try {
      storage.setItem(storageKey, JSON.stringify(value));
      return storage.getItem(storageKey) !== null;
    } catch { return false; }
  };
  const session = (() => { try { return window.sessionStorage; } catch { return null; } })();
  const persistent = (() => { try { return window.localStorage; } catch { return null; } })();
  const savedVisit = read(session, key);
  const statuses = new Set(['new', 'checking', 'matched', 'correcting', 'corrected', 'manual', 'failed', 'unsupported', 'deferred', 'storage_unavailable', 'missing_token', 'loop_prevented', 'context_changed']);
  const sources = new Set(['', 'ipinfo', 'url', 'manual']);
  const isVisit = value => value && typeof value === 'object' && !Array.isArray(value) &&
    Number.isFinite(value.lastSeen) && value.lastSeen <= Date.now() &&
    Number.isInteger(value.attempts) && value.attempts >= 0 && value.attempts <= 1 &&
    statuses.has(value.status) && sources.has(value.source) &&
    (value.country === '' || validCountry(value.country));
  const cached = isVisit(savedVisit) && Date.now() - savedVisit.lastSeen < visitDuration ? savedVisit : null;
  visit = cached || { country: '', source: '', status: 'new', attempts: 0, lastSeen: Date.now(), firstNavigationAt: performance.timeOrigin || Date.now() };
  if (cached?.lookupMs != null) root.dataset.lookupMs = String(cached.lookupMs);
  if (cached?.correctionMs != null) root.dataset.correctionMs = String(cached.correctionMs);
  if (cached?.countryReadyMs != null) root.dataset.countryReadyMs = String(cached.countryReadyMs);

  const storeVisit = () => {
    visit.lastSeen = Date.now();
    return write(session, key, visit);
  };
  const report = (...args) => {
    try { if (typeof window.clarity === 'function') window.clarity(...args); } catch {}
  };
  const telemetry = () => {
    report('set', 'tgw_country_applied', currentCountry);
    report('set', 'tgw_country_target', visit.country || 'unknown');
    report('set', 'tgw_country_source', visit.source || 'unknown');
    report('set', 'tgw_country_status', visit.status);
    report('set', 'tgw_country_theme', root.dataset.themeId);
  };
  const status = value => {
    visit.status = value;
    root.dataset.status = value;
    root.dataset.targetCountry = visit.country || '';
    root.dataset.source = visit.source || '';
    root.dataset.durationMs = String(Math.round(performance.now() - startTime));
    storeVisit();
    telemetry();
  };
  const showNotice = () => { if (notice) notice.hidden = false; };
  const returnPath = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('country');
    const prefix = (root.dataset.root || '/').replace(/\/$/, '');
    if (prefix && (url.pathname === prefix || url.pathname.startsWith(`${prefix}/`))) {
      url.pathname = url.pathname.slice(prefix.length) || '/';
    }
    return `${url.pathname}${url.search}${url.hash}`;
  };
  const setField = (form, name, value) => {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };
  const prepareForm = form => {
    setField(form, 'return_to', returnPath());
    setField(form, 'locale_code', root.dataset.language);
    setField(form, 'language_code', root.dataset.language);
  };
  const restoreScroll = () => {
    const position = visit.scroll;
    if (!position) return;
    delete visit.scroll;
    storeVisit();
    if (position.country !== currentCountry || position.path !== returnPath() ||
      !Number.isFinite(position.at) || position.at > Date.now() || Date.now() - position.at > 60000 ||
      !Number.isFinite(position.x) || !Number.isFinite(position.y) || position.x < 0 || position.y < 0) return;
    let cancelled = false;
    const cleanup = () => {
      document.removeEventListener('pointerdown', cancel, true);
      document.removeEventListener('keydown', cancel, true);
      document.removeEventListener('wheel', cancel, true);
    };
    const cancel = () => { cancelled = true; cleanup(); };
    const schedule = final => window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      if (!cancelled) window.scrollTo({ left: position.x, top: position.y, behavior: 'instant' });
      if (final) cleanup();
    }));
    document.addEventListener('pointerdown', cancel, { once: true, capture: true, passive: true });
    document.addEventListener('keydown', cancel, { once: true, capture: true });
    document.addEventListener('wheel', cancel, { once: true, capture: true, passive: true });
    if (document.readyState === 'complete') schedule(true);
    else {
      schedule(false);
      window.addEventListener('load', () => schedule(true), { once: true });
    }
  };
  const applyCountry = country => {
    if (!pageActive) return;
    if (!validCountry(country) || !autoForm) {
      status('unsupported');
      showNotice();
      return;
    }
    if (country === currentCountry) {
      restoreScroll();
      visit.attempts = 0;
      status('matched');
      return;
    }
    if (visit.attempts >= 1) {
      status('loop_prevented');
      showNotice();
      return;
    }
    visit.attempts += 1;
    if (!storeVisit()) {
      status('storage_unavailable');
      showNotice();
      return;
    }
    prepareForm(autoForm);
    setField(autoForm, 'country_code', country);
    visit.scroll = { country, path: returnPath(), x: window.scrollX, y: window.scrollY, at: Date.now() };
    visit.correctionStartedAt = Date.now();
    status('correcting');
    report('event', 'TGW_country_correction');
    try { HTMLFormElement.prototype.submit.call(autoForm); } catch {
      status('failed');
      showNotice();
    }
  };
  const chooseManually = (country, form) => {
    if (!validCountry(country)) return;
    manualCountry = country;
    delete visit.scroll;
    controller?.abort();
    write(persistent, preferenceKey, { country, expires: Date.now() + preferenceDuration });
    visit.country = country;
    visit.source = 'manual';
    visit.attempts = 0;
    prepareForm(form);
    status('manual');
  };
  const isLocalizationForm = form => form instanceof HTMLFormElement && form !== autoForm && Boolean(form.querySelector('input[name="form_type"][value="localization"]'));

  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[name="country_code"], input[type="submit"][name="country_code"]');
    if (button && isLocalizationForm(button.form)) chooseManually(countryCode(button.value), button.form);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!isLocalizationForm(form)) return;
    const selector = form.querySelector('select[name="country_code"]');
    const button = event.submitter;
    const country = button?.name === 'country_code' ? button.value : selector?.value;
    if (country) chooseManually(countryCode(country), form);
  }, true);
  document.addEventListener('change', event => {
    const selector = event.target;
    if (selector instanceof HTMLSelectElement && selector.hasAttribute('data-tgw-country-select') && isLocalizationForm(selector.form)) {
      chooseManually(countryCode(selector.value), selector.form);
      if (typeof selector.form.requestSubmit === 'function') selector.form.requestSubmit();
      else HTMLFormElement.prototype.submit.call(selector.form);
    }
  });
  document.querySelectorAll('[data-tgw-country-confirm]').forEach(button => { button.hidden = true; });
  window.addEventListener('pagehide', () => {
    pageActive = false;
    if (visit.status === 'checking' && !visit.country) {
      try { session?.removeItem(key); } catch {}
    }
    controller?.abort();
  });
  let refreshedRestore = false;
  window.addEventListener('pageshow', event => {
    pageActive = true;
    if (!event.persisted || refreshedRestore) return;
    const latest = read(session, key);
    if (isVisit(latest) && validCountry(latest.country) && latest.country !== currentCountry && ['matched', 'corrected', 'manual'].includes(latest.status)) {
      refreshedRestore = true;
      window.location.reload();
    }
  });

  const run = async () => {
    const preference = read(persistent, preferenceKey);
    const preferred = preference?.expires > Date.now() ? countryCode(preference.country) : '';
    const urlCountry = countryCode(new URL(window.location.href).searchParams.get('country'));

    if (preferred) {
      visit.country = preferred;
      visit.source = 'manual';
      applyCountry(preferred);
      return;
    }
    if (urlCountry) {
      visit.country = urlCountry;
      visit.source = 'url';
      applyCountry(urlCountry);
      return;
    }
    if (cached && !(visit.status === 'checking' && !visit.country)) {
      if (visit.status === 'correcting' && visit.country === currentCountry) {
        restoreScroll();
        visit.attempts = 0;
        if (Number.isFinite(visit.correctionStartedAt)) {
          visit.correctionMs = Math.max(0, Date.now() - visit.correctionStartedAt);
          root.dataset.correctionMs = String(visit.correctionMs);
        }
        if (Number.isFinite(visit.firstNavigationAt)) {
          visit.countryReadyMs = Math.max(0, Date.now() - visit.firstNavigationAt);
          root.dataset.countryReadyMs = String(visit.countryReadyMs);
        }
        status('corrected');
      }
      else if (visit.status === 'deferred' && visit.country && visit.country !== currentCountry && visit.attempts === 0) {
        applyCountry(visit.country);
      }
      else if (visit.country && visit.country !== currentCountry) {
        status(visit.status === 'correcting' ? 'loop_prevented' : 'context_changed');
        showNotice();
      } else {
        root.dataset.status = visit.status;
        root.dataset.targetCountry = visit.country || '';
        root.dataset.source = visit.source || '';
        storeVisit();
        telemetry();
        if (['failed', 'unsupported', 'missing_token', 'storage_unavailable', 'deferred', 'checking'].includes(visit.status)) showNotice();
      }
      return;
    }
    if (!storeVisit()) {
      status('storage_unavailable');
      showNotice();
      return;
    }
    if (!root.dataset.apiToken) {
      status('missing_token');
      showNotice();
      return;
    }
    if (typeof fetch !== 'function' || typeof AbortController !== 'function') {
      status('unsupported');
      showNotice();
      return;
    }
    controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3500);
    const lookupStartedAt = performance.now();
    visit.source = 'ipinfo';
    status('checking');
    try {
      const response = await fetch(`https://api.ipinfo.io/lite/me?token=${encodeURIComponent(root.dataset.apiToken)}`, {
        signal: controller.signal,
        credentials: 'omit',
        cache: 'no-store',
        referrerPolicy: 'origin'
      });
      if (!response.ok) throw new Error('Country lookup unavailable');
      const data = await response.json();
      visit.lookupMs = Math.round(performance.now() - lookupStartedAt);
      root.dataset.lookupMs = String(visit.lookupMs);
      if (manualCountry) return;
      const country = countryCode(data?.country_code);
      if (!country || data.bogon || data.is_bogon || data.is_anycast) {
        status('unsupported');
        showNotice();
        return;
      }
      visit.country = country;
      applyCountry(country);
    } catch {
      if (!manualCountry && pageActive) {
        status('failed');
        showNotice();
      }
    } finally {
      clearTimeout(timeout);
    }
  };

  run();
  root.dataset.setupMs = String(Math.round((performance.now() - startTime) * 100) / 100);
})();

